/**
 * Soft onboarding: incomplete testers may use a limited set of app routes
 * (dashboard, academy, guide, chat, settings/profile) instead of being trapped
 * on /tester-complete-profile.
 */

export const INCOMPLETE_PROFILE_ALLOWED_PREFIXES = [
  '/app/dashboard',
  '/app/academy',
  '/app/user-guide',
  '/app/messages',
  '/app/settings',
  '/app/tester-profile',
  '/app/profile',
  '/tester-complete-profile',
];

/** Paths (and actions) locked in the tester nav until profileCompleted. */
const LOCKED_NAV_PATHS = new Set([
  '/app/open-cycles',
  '/app/test-cycles',
  '/app/my-reported-issues',
  '/app/earnings',
]);

export function isIncompleteProfilePathAllowed(pathname) {
  if (!pathname) return false;
  return INCOMPLETE_PROFILE_ALLOWED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function isNavLockedForIncompleteProfile(item) {
  if (!item) return false;
  if (item.action === 'reportBug') return true;
  return Boolean(item.path && LOCKED_NAV_PATHS.has(item.path));
}
